import { useCallback, useMemo } from "react";
import "../../Stylesheets/tableV2.css";

export const Pagination = ({
  currentPage,
  totalPages,
  pageSize,
  totalEntries,
  onPageChange,
  showEntriesInfo = true,
}) => {
  const [startEntry, endEntry] = useMemo(() => {
    const start = (currentPage - 1) * pageSize + 1;
    const end = Math.min(currentPage * pageSize, totalEntries);
    return [start, end];
  }, [currentPage, pageSize, totalEntries]);

  const getPageNumbers = useCallback(() => {
    const range = [];
    const maxPages = 5;

    if (totalPages <= maxPages) {
      // If total pages is 5 or less, show all pages
      for (let i = 1; i <= totalPages; i++) {
        range.push(i);
      }
    } else {
      // Show 5 pages centered around current page
      let start = Math.max(1, currentPage - 2);
      let end = Math.min(totalPages, start + maxPages - 1);

      // Adjust start if end is maxed out
      if (end === totalPages) {
        start = Math.max(1, end - maxPages + 1);
      }

      for (let i = start; i <= end; i++) {
        range.push(i);
      }
    }

    return range;
  }, [currentPage, totalPages]);

  return (
    <div className="pagination-container">
      {showEntriesInfo ? (
        <div className="entries-info">
          {totalEntries > 0
            ? `Showing ${startEntry} to ${endEntry} of ${totalEntries} entries`
            : "Showing 0 entries"}
        </div>
      ) : (
        <div></div>
      )}
      {totalPages > 1 && (
        <nav>
          <ul className="pagination justify-content-end">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => onPageChange(1)}
                disabled={currentPage === 1}
              >
                First
              </button>
            </li>
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>
            </li>

            {getPageNumbers().map((pageNum, idx) => (
              <li
                key={idx}
                className={`page-item ${
                  pageNum === currentPage ? "active" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => onPageChange(pageNum)}
                >
                  {pageNum}
                </button>
              </li>
            ))}

            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </li>
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => onPageChange(totalPages)}
                disabled={currentPage === totalPages}
              >
                Last
              </button>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
};
export default Pagination;
